import BResultsChanges from './BResultsChanges'

export default BResultsChanges
